import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import AppShell from './components/layout/AppShell';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import PintoPage from './pages/PintoPage';
import ProfilePage from './pages/ProfilePage';
import Toast from './components/ui/Toast';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { member, loading } = useAuth();
  
  if (loading) {
    return <div className="loading-screen">กำลังโหลด...</div>;
  }
  
  if (!member) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const App = () => {
  return (
    <>
      <Toast />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        
        <Route 
          path="/" 
          element={
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="pinto" element={<PintoPage />} />
          <Route path="profile" element={<ProfilePage />} />
        </Route>
      </Routes>
    </>
  );
};

export default App;
